/**
 * Implement Gatsby's Browser APIs in this file.
 * @see https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */
import "./src/styles/global.css"

/**
 * Make every full page load start at the top — unless the URL has a "#anchor",
 * in which case it scrolls to that section.
 *
 * Gatsby saves the last scroll position for each route in sessionStorage
 * (`@@scroll|<path>|<key>`) and restores it on reload, which made a hash-less
 * "/" jump to wherever the user previously scrolled. We clear those saved
 * positions before the app mounts so there is nothing to restore; Gatsby then
 * falls through to its hash handling (so real "#anchor" links still work).
 */
export const onClientEntry = () => {
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual"
  }
  if (typeof window !== "undefined" && window.sessionStorage) {
    Object.keys(window.sessionStorage)
      .filter((key) => key.startsWith("@@scroll|"))
      .forEach((key) => window.sessionStorage.removeItem(key))
  }
}
